import {KeycloakService} from 'keycloak-angular';
import {EnvironmentService} from 'app/core/environment/environment.service';

export function initializeKeycloak(keycloakService: KeycloakService, environmentService: EnvironmentService): () => Promise<boolean> {

    return () =>
        keycloakService.init({
            config: {
                url: environmentService.authServerApiUrl + '/auth',
                realm: 'HealthBank',
                clientId: 'BayerConsentWebApp',
            },
            initOptions: {
                onLoad: 'check-sso',
                silentCheckSsoRedirectUri: window.location.origin + '/assets/silent-check-sso.html',
                checkLoginIframe: true,
                checkLoginIframeInterval: 25,
            },
            loadUserProfileAtStartUp: true,
            enableBearerInterceptor: true,
            bearerExcludedUrls: ['/public', '/assets']
        });
}
